<div class="products">
    <div class="product" *ngFor="let item of products">
        <mat-card>
            <p>{{item.title}}</p>
            <p>$ <strong>{{item.price}}</strong></p>
            <img src={{item.image}}>
            <button (click)="addToCart(item)">Add to cart</button>
        </mat-card>
    </div>

</div>
